import {Component, OnInit, Pipe, PipeTransform, ViewChild, ViewEncapsulation} from '@angular/core';
import {MessageService} from 'primeng/api';
import {ExcRestService} from 'exc-rest';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {DomSanitizer, Title} from '@angular/platform-browser';
import {ExcSigninService} from 'exc-signin';
import {TranslateService} from '@ngx-translate/core';
import {ExcTab, ExcTabService} from 'exc-tab';
import {ExcActionService, OverlayService} from 'exc-controls';
import {ActivatedRoute, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {DefaultSettingsService} from './default-settings-service.service';
import {ExconAuditDetailsComponent} from './excon/excon-audit-details/excon-audit-details.component';

@Pipe({name: 'htmlContent'})
export class HtmlContentPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {
  }

  transform(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [MessageService]
})


export class AppComponent extends ExcTranslation implements OnInit {
  @ViewChild('languageMenu') languageMenu;
  core = ExcCoreModule;
  title = ExcCoreModule.Config().Environment.appName;
  vistanr = '';
  constructor(public tabService: ExcTabService,
              private titleService: Title,
              private excRestService: ExcRestService,
              public excSignInService: ExcSigninService,
              private messageService: MessageService,
              private overlayService: OverlayService,
              private excActionService: ExcActionService,
            private router: Router,
            public dss: DefaultSettingsService
  , private route: Router) {
  super();
    const _self = this;
    ExcCoreModule.on('eAM.ShowSuccess', function (message, title) {
      _self.messageService.add({severity: 'success', summary: title, detail: message, life: 1500});
    });
    ExcCoreModule.on('eAM.ShowInfo', function (message, title) {
      _self.messageService.add({severity: 'info', summary: title, detail: message, life: 1500});
    });
    ExcCoreModule.on('eAM.ShowWarning', function (message, title) {
      _self.messageService.add({severity: 'warn', summary: title, detail: message, life: 5000});
    });
    ExcCoreModule.on('eAM.ShowError', function (message, title) {
      _self.messageService.add({severity: 'error', sticky: true, summary: title, detail: message});
    });
    ExcCoreModule.on('ExcSignIn.RevalidateToken', function () {
      _self.tabService.RemoveAll(undefined);
      _self.router.navigate(['/']);
    });
    this.titleService.setTitle(ExcCoreModule.Config().Environment.appName);
    // set default language
    this.translateService.setDefaultLang('de');
    this.setLanguage();
  }

  getUserlist() {
    if (this.excSignInService.ParallelLogins) {
      return JSON.parse(this.excSignInService.ParallelLogins);
    }
    return [];
  }

  changeUser(uid: string) {
    this.excSignInService.changeUser(uid);
  }
  handleShortcutPress(e) {
    if (e.key === 'Enter' && this.vistanr.length > 5) {
      new ExcTab(this.vistanr, ExconAuditDetailsComponent, {AuditID: this.vistanr}, this.vistanr, {
        Unique: true
      }, true).Open();
      this.vistanr = '';
    }

  }

  ngOnInit(): void {
    const _self = this;
  }



  getNavigation() {
    const _self = this;
    for (const r of ExcCoreModule.Services().Router.config) {
      const t = _self.getGlobal('PATH_' + r.path);
      if (t && t.length > 0 && r.data) {
        r.data.fn = t;
        r.data.friendlyName = () => { return r.data.fn; };
      }
    }
    return ExcCoreModule.Services().Router.config.filter(e => !!!e.hidden);
  }

  public setLanguage(lang?: string) {
    const _self = this;
    lang = lang || localStorage.getItem('appLanguage') || this.translateService.getDefaultLang();
    this.translateService.use(lang)
      .subscribe(
        data => {
          localStorage.setItem('appLanguage', lang);
          if (this.languageMenu && this.languageMenu.visible) {
            this.languageMenu.hide();
          }
          const path = _self.route.url.substring(1, _self.route.url.length);
          for (const c of _self.route.config) {
            if (c.path === path) {
              setTimeout(() => {
                _self.translateService.get(c.data.fn).subscribe(x => {
                  ExcCoreModule.call('excTab.ChangeStateLabel', x);
                });
              }, 20);
              break;
            }
          }
        },
        err => this.setLanguage(this.translateService.getDefaultLang())
      );
  }

}
